<template>
    <div>
        <p class="f-110 fw-500 mb-1">{{ $t('평가신청 및 기업 평가 관리자 정보') }}</p>

        <div class="bg-warning rounded-bottom text-center p-3 mb-3">
            <div v-show="$i18n.locale === 'ko'">
                <p class="fw-400 f-95 mb-3">
                    <b>"{{ selected_vendor.company.company_name }}" 기업은 이미
                        평가신청된 상태입니다.</b> <br>
                    평가 신청 시 "평가 참여 관리자"에 참여승인 요청 이메일이 발송되며, <br> 관리자의 승인 후
                    <b>"평가 참여자"</b> 로 등록됩니다.
                </p>
                <p class="fw-400 f-95 mb-0">만약 평가 관리자 정보에 오류가 있다면, 평가 안내
                    URL을 다시 확인하거나 평가 주관기관에 문의해 주시기 바랍니다.</p>
            </div>
            <div v-show="$i18n.locale === 'en'">
                <p class="fw-400 f-95 mb-3">
                    <b>The company "{{
                            selected_vendor.company.company_name
                        }}" has already applied for evaluation.</b> <br>
                    When applying for an evaluation, a confirmation request
                    email will be sent to the "Evaluation Participation
                    Manager", and after the manager's approval, you will be
                    registered as an <b>"Evaluation Participant"</b>.

                </p>
                <p class="fw-400 f-95 mb-0">If there is an error in the
                    administrator information, please check the evaluation
                    guide URL again or contact the evaluation agency.</p>
            </div>
            <div v-show="$i18n.locale === 'ca'">
                <p class="fw-400 f-95 mb-3">
                    <b>公司 “{{ selected_vendor.company.company_name }}”
                        申请评估。</b> <br>
                    申请评估时，系统会向“评估参与经理”发送一封确认请求电子邮件，经经理批准后，您将被注册为<b>“评估参与者”</b>。
                </p>
                <p class="fw-400 f-95 mb-0">如果管理员信息不正确，请再次检查评估指南URL或联系评估机构。</p>
            </div>
        </div>

        <b-table-simple bordered responsive class="mb-2">
            <b-thead class="bgray-200">
                <b-tr>
                    <b-th>{{ $t('평가 관리자 정보') }}</b-th>
                    <b-th>{{ $t('관리자 이메일') }}</b-th>
                    <b-th>{{ $t('최초 신청일') }}</b-th>
                </b-tr>
            </b-thead>
            <b-tbody>
                <b-tr>
                    <b-td>{{ selected_vendor.manager.user_name }}</b-td>
                    <b-td>{{ selected_vendor.manager.e_mail }}</b-td>
                    <b-td>{{ selected_vendor.validated_at }}</b-td>
                </b-tr>
            </b-tbody>
        </b-table-simple>
    </div>
</template>

<script>
import {mapState} from 'vuex';

export default {
    name: 'ValidatedVendorCodeGuide',
    data() {
        return {
            loading: false,
        };
    },
    computed: {
        ...mapState('register',['selected_vendor'])
    },
    methods: {
    },
    mounted() {
    }
};
</script>

<style lang="scss" scoped>

</style>
